export default "__VITE_ASSET__7a385e51__"